export const datashares = "/datashares";
